import React from "react";
import * as S from "../style";
import { Grid } from "@mui/material";
import MixedChart from "defaultComponents/Charts/MixedCharts/MixedChart";
import BarChart from "./BarChart";
import { IoArrowUp, IoArrowDown } from "react-icons/io5";
import Card from "@mui/material/Card";
import { abbreviateNumbers } from "utils/utils";

const TiktokCommunity = ({ socialData }) => {
  const [mixedChartData, setMixedChartData] = React.useState([
    {
      name: "Seguidores",
      type: "column",
      data: [],
    },
    {
      name: "Posts",
      type: "line",
      data: [],
    },
  ]);

  const [barChartData, setBarChartData] = React.useState([
    {
      name: "Novos Seguidores",
      data: [],
    },
  ]);

  const [categories, setCategories] = React.useState([]);

  React.useEffect(() => {
    if (socialData?.metrics?.length > 0) {
      const socialDataMetrics = socialData?.metrics;
      const categoriesMixedChart =
        socialData?.metrics
          ?.find((metric) => metric.name == "week")
          ?.data.map((item) =>
            new Date(item).toLocaleDateString("pt-BR", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })
          ) ?? [];
      const postsMixedChart =
        socialData?.metrics?.find((metric) => metric.name == "tiktok_video_count")?.data ?? [];
      const followersMixedChart =
        socialData?.metrics?.find((metric) => metric.name == "tiktok_followers")?.data ?? [];
      const newFollowersBarChart = [
        {
          name: "Novos Seguidores",
          data:
            socialData?.metrics?.find((metric) => metric.name == "tiktok_weekly_new_followers")
              ?.data ?? [],
          type: "bar",
        },
      ];
      const newMixedChartData = [...mixedChartData];

      setCategories(categoriesMixedChart);
      newMixedChartData[0].data = followersMixedChart;
      newMixedChartData[1].data = postsMixedChart;
      setMixedChartData(newMixedChartData);
      setBarChartData(newFollowersBarChart);
    }
  }, [socialData]);

  return (
    <Grid container spacing="18px">
      <Grid item xs={12} lg={12} xl={12}>
        <Card>
          <Grid display="flex" gap="30px" flexDirection="column">
            <Grid>
              <Grid container justifyContent="space-between">
                <Grid item xl={6}>
                  <p style={{ color: "white" }}>Growth</p>
                </Grid>
                <Grid container item xl={6} justifyContent="flex-end" gap="10px">
                  <S.InfoBlock item xs={2} xl={3} sx={{ backgroundColor: "#83848A" }}>
                    <Grid container justifyContent="center">
                      <p>{abbreviateNumbers(socialData?.followers) ?? 0}</p>
                      {socialData?.followersTrend === "up" ? (
                        <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                      ) : (
                        <IoArrowDown color="#FF4D4D" size="16px" style={{ alignSelf: "center" }} />
                      )}
                    </Grid>
                    <p className="subTitle">Seguidores</p>
                  </S.InfoBlock>
                  <S.InfoBlock item xs={2} xl={2} sx={{ backgroundColor: "#FC6009" }}>
                    <Grid container justifyContent="center">
                      <p>{abbreviateNumbers(socialData?.posts) ?? 0}</p>
                      {socialData?.postsTrend === "up" ? (
                        <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                      ) : (
                        <IoArrowDown color="#FF4D4D" size="16px" style={{ alignSelf: "center" }} />
                      )}
                    </Grid>
                    <p className="subTitle">Posts</p>
                  </S.InfoBlock>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={{ minHeight: "300px" }}>
              <MixedChart series={mixedChartData} categories={categories} />
            </Grid>
            <Grid container item xl={12} justifyContent="space-evenly">
              <S.InfoBlock item xs={2} xl={1.5}>
                <p>{abbreviateNumbers(socialData?.followers) ?? 0}</p>
                <p className="subTitle">Seguidores</p>
              </S.InfoBlock>
              <S.InfoBlock item xs={2} xl={1.5}>
                <p>{abbreviateNumbers(Number(socialData?.weeklyFollowers).toFixed(2)) ?? 0}</p>
                <p className="subTitle">Seguidores semanais</p>
              </S.InfoBlock>
              <S.InfoBlock item xs={2} xl={1.5}>
                <p>{abbreviateNumbers(socialData?.following) ?? 0}</p>
                <p className="subTitle">Seguindo</p>
              </S.InfoBlock>
              <S.InfoBlock item xs={2} xl={1.5}>
                <p>{abbreviateNumbers(socialData?.weeklyPosts) ?? 0}</p>
                <p className="subTitle">Posts por semana</p>
              </S.InfoBlock>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} lg={12} xl={12}>
        <Card>
          <Grid container justifyContent="space-between">
            <p style={{ color: "#fff" }}>Novos Seguidores</p>
            <S.InfoBlock item xs={2} xl={2}>
              <Grid container justifyContent="center">
                <p>{abbreviateNumbers(socialData?.newFollowers) ?? 0}</p>
                {socialData?.newFollowersTrend === "up" ? (
                  <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                ) : (
                  <IoArrowDown color="#FF4D4D" size="16px" style={{ alignSelf: "center" }} />
                )}
              </Grid>
              <p className="subTitle">Novos Seguidores</p>
            </S.InfoBlock>
          </Grid>
          <Grid sx={{ minHeight: "300px" }}>
            <BarChart chartData={barChartData} chartCategories={categories} />
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TiktokCommunity;
